import { faCircleArrowUp } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton } from '@nexelem/components';
import { cn } from '@nexelem/utils';
import { useEffect, useState } from 'react';

export const SCROLL_CONTAINER_CLASSNAME = 'table-scroll-container';

export const ScrollUpButton = () => {
  const [canScrollUp, setCanScrollUp] = useState(false);

  useEffect(() => {
    const scrollContainer = document.querySelector(`.${SCROLL_CONTAINER_CLASSNAME}`);
    if (!scrollContainer) {
      return;
    }

    const handleScroll = () => {
      setCanScrollUp(scrollContainer.scrollTop > 0);
    };

    handleScroll();

    scrollContainer.addEventListener('scroll', handleScroll);

    return () => {
      scrollContainer.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    const scrollContainer = document.querySelector(`.${SCROLL_CONTAINER_CLASSNAME}`);
    scrollContainer?.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <IconButton
      className={cn(!canScrollUp && 'invisible')}
      Icon={<FontAwesomeIcon icon={faCircleArrowUp} />}
      onClick={scrollToTop}
    />
  );
};
